
















import { Vue, Component, Watch } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";
import {
  SettingsGetters,
  SettingsMutations,
  SettingsTitle
} from "@/components/settings/types";
import { Namespace } from "@/store/types";
import { ChannelId, MyChannel } from "@/services/apiService/api.types";
import apiStorageInterface from "@/services/apiStorageInterface";
import SettingsChannelCard from "@/components/settings/components/channelsortAndLock/SettingsChannelCard.vue";
import SpatialNavigation from "spatial-navigation-js";
import apiService from "@/services/apiService/apiService";
import { LocaleSettingsPageTitles } from "@/plugins/i18n/types";
import { i18n } from "@/plugins/i18n/vue-i18n-plugin";

const shuffle = ([...arr], currPos: number, newPos: number) => {
  if (newPos > currPos) {
    for (let i = currPos; i < newPos; i++) {
      [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]];
    }

    return arr;
  }

  for (let i = currPos; i > newPos; i--) {
    [arr[i], arr[i - 1]] = [arr[i - 1], arr[i]];
  }
  return arr;
};

@Component({
  components: {
    SettingsChannelCard
  }
})
export default class ChannelSortAndLock extends Vue {
  @Mutation(SettingsMutations.setSettingsPageTitle, {
    namespace: Namespace.Settings
  })
  setSettingsPageTitle!: (settingsPageTitle?: SettingsTitle) => void;

  @Mutation(SettingsMutations.setChannelCardCurrPos, {
    namespace: Namespace.Settings
  })
  setChannelCardCurrPos!: (pos?: number) => void;

  @Mutation(SettingsMutations.setChannelCardNewPos, {
    namespace: Namespace.Settings
  })
  setChannelCardNewPos!: (pos?: number) => void;

  @Getter(SettingsGetters.getChannelCardCurrPos, {
    namespace: Namespace.Settings
  })
  getChannelCardCurrPos?: number;

  @Getter(SettingsGetters.getChannelCardNewPos, {
    namespace: Namespace.Settings
  })
  getChannelCardNewPos!: number;

  channelList: MyChannel[] = [];
  channelIndexArr: number[] = [];

  LocaleSettingsPageTitles = LocaleSettingsPageTitles;

  created(): void {
    this.setSettingsPageTitle({
      heading: i18n.t(
        this.LocaleSettingsPageTitles.settingsSortAndLockTitle
      ) as string,
      subHeading: i18n.t(
        this.LocaleSettingsPageTitles.settingsEditUserSubTitle
      ) as string
    });
  }
  async mounted(): Promise<void> {
    await this.fetchUpToDateChannelList();
    SpatialNavigation.resume();
    this.channelIndexArr = this.channelList.map((channel, index) => index);
  }

  /*
   * triggered when channel is  added/removed from favourite,
   * updated at once in case a user goes to a page where that info is relevant
   */
  async fetchUpToDateChannelList(): Promise<void> {
    //updating sorted categories as well since it contains channel info as well
    await apiStorageInterface.fetchSortedCategories(true);
    this.channelList = await apiStorageInterface.fetchCustomChannelList(true);
  }

  switchItems(currentPos = 0, newPos = 0): void {
    this.channelIndexArr = shuffle(this.channelIndexArr, currentPos, newPos);
  }

  async reorderChannels(): Promise<void> {
    let channelOrder: ChannelId[] = this.channelIndexArr.map(
      (channelIndex: number) => {
        return { id: this.channelList[channelIndex].id };
      }
    );
    try {
      await apiService.channelReorder(channelOrder);
      //auto updates localStorage channelList as well
      await apiStorageInterface.fetchSortedCategories(true);
    } catch (e) {
      console.log(e);
    }
  }

  @Watch("getChannelCardNewPos")
  handlePositionChange(): void {
    if (
      typeof this.getChannelCardNewPos !== "undefined" &&
      this.getChannelCardNewPos >= 0 &&
      this.getChannelCardNewPos < this.channelIndexArr.length
    ) {
      this.switchItems(this.getChannelCardCurrPos, this.getChannelCardNewPos);
      this.setChannelCardCurrPos(this.getChannelCardNewPos);
      this.setChannelCardNewPos();
    }
  }
}
